import script from "./ViewVehicleModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewVehicleModal.vue?vue&type=script&setup=true&lang=ts"

import "./ViewVehicleModal.vue?vue&type=style&index=0&id=5ae539b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ae539b6"]])

export default __exports__